import React from 'react';
import {charts} from './style';
import {
  VerticalBarSeries,
  HorizontalBarSeries,
  makeVisFlexible,
  XAxis,
  XYPlot,
  YAxis
} from 'react-vis';

const FlexibleXYPlot = makeVisFlexible(XYPlot);

export default function Charts({
  geneland,
  colors,
  highlight
}) {

  if (!geneland) {
    return(<div style={charts}/>);
  }

  Object.entries(geneland).forEach(([family, dataSet]) => {
    let color = colors[family];
    dataSet.forEach(dataPoint => dataPoint['color'] = color);
  });

  return (
    <div style={charts}>
      <FlexibleXYPlot
        stackBy='x'
        yType='ordinal'
        onMouseLeave={() => highlight(null)}
      >
        <YAxis />
        {Object.keys(geneland).map(key =>
          <HorizontalBarSeries
            key={key}
            colorType='literal'
            data={geneland[key]}
            onValueMouseOver={d => highlight(d.lion)}
          />)}
      </FlexibleXYPlot>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/charts.js